import React, { Component } from "react";
import BsySLoading from "../BsySLoading";
import { BsyUtils } from "../../utils/Utils";

class UpdateStandardAppPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      standardUpdateData: props.standardUpdateData || {},
      appsMap: {},
      appId: props.appId || "",
    };
  }

  setValue = (t, standardUpdateCont) => {
    let appsMap = {};
    t.map((item) => {
      item.apps.map((app) => {
        appsMap[app._id] = app;
      });
    });
    if (!standardUpdateCont.hasRenew) {
      this.props.slideRef.closeAlter();
    }
    this.setState({ appsMap, standardUpdateData: standardUpdateCont });
  };

  componentDidMount() {
    let appsMap = {};
    this.props.apps.map((item) => {
      item.apps.map((app) => {
        appsMap[app._id] = app;
      });
    });
    this.setState({ appsMap });
  }

  changeShowHide = (e) => {
    const t = BsyUtils.closestClass(e.currentTarget, "updateStandardAppItem");
    if (t.classList.value.indexOf("show") > -1) {
      t.classList.remove("show");
      e.currentTarget.childNodes[0].classList.add("icon-down1");
      e.currentTarget.childNodes[0].classList.remove("icon-up1");
      e.currentTarget.childNodes[1].innerText = React.language("display.show");
    } else {
      t.classList.add("show");
      e.currentTarget.childNodes[0].classList.add("icon-up1");
      e.currentTarget.childNodes[0].classList.remove("icon-down1");
      e.currentTarget.childNodes[1].innerText = React.language("collect");
    }
  };

  updateProject = (r) => {
    return () => {
      window.hasUpdateApp = true;
      this.setState({ isLoading: true }, () => {
        React.axios("/dashboard/standard_renew_app", {
          _id: r._id,
        })
          .then((res) => {
            React.axios("/dashboard/app_group/list").then((res) => {
              const storeAppList = BsyUtils.Store.get("appNewList");
              const appOldList = []; //storeAppOldList || [];
              const appNewList = [];
              if (BsyUtils.isObjectEmpty(storeAppList)) {
                this.props.apps.map((item) => {
                  item.apps.map((app) => {
                    appOldList.push(app._id);
                    return null;
                  });
                  return null;
                });
              } else {
                this.props.apps.map((item) => {
                  item.apps.map((app) => {
                    if (!storeAppList.includes(app._id)) {
                      appOldList.push(app._id);
                    }
                    return null;
                  });
                  return null;
                });
              }
              res.data.items.map((item) => {
                item.apps.map((app) => {
                  if (appOldList.indexOf(app._id) < 0) {
                    appNewList.push(app._id);
                  }
                  return null;
                });
                return null;
              });
              BsyUtils.Store.set("appNewList", [
                ...appNewList,
                ...storeAppList,
              ]);
              this.setState({ isLoading: false });
              this.props.loadAppList(this.setValue);
            });
          })
          .catch((res) => {
            this.setState({ isLoading: false });
          });
      });
    };
  };

  render() {
    const { isLoading, standardUpdateData, appsMap } = this.state;
    return (
      <div className="UpdateStandardAppPane">
        {isLoading && <BsySLoading style={{ background: "#ffffff" }} />}
        <div className="updateStandardAppContent">
          {(standardUpdateData?.list || [])
            .filter((item) =>
              !this.state.appId ? true : item.appIds.includes(this.state.appId)
            )
            .map((res, key) => {
              return (
                <div
                  className={`updateStandardAppItem ${key === 0 ? "show" : ""}`}
                >
                  <div className="item-header">
                    <div className="header-left">
                      <div className="project-name" title={res.name}>
                        {res.name}
                      </div>
                      <div className="project-version">{res.version}</div>
                    </div>
                    <div className="header-right">
                      <div
                        className="updateStandardAppBtn"
                        onClick={this.updateProject(res)}
                      >
                        <i className="icon-bsy-reportmenu-15"></i>
                        <span>{React.language("update.project.app")}</span>
                      </div>
                      {this.state.appId ? (
                        ""
                      ) : (
                        <div
                          className="showHideBtn"
                          onClick={this.changeShowHide}
                        >
                          <i
                            className={key === 0 ? "icon-up1" : "icon-down1"}
                          ></i>
                          <span>
                            {key === 0
                              ? React.language("collect")
                              : React.language("display.show")}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="item-body">
                    <div className="body-item">
                      <div className="item-title">
                        {React.language("Update.cont")}
                      </div>
                      <div className="item-cont">
                        <div className="update-cont">{res.remark}</div>
                      </div>
                    </div>
                    <div className="body-item">
                      <div className="item-title">
                        {React.language("Doc.link")}
                      </div>
                      <div className="item-cont">
                        <a href={res.docUrl} target={"_blank"}>
                          {res.docUrl}
                        </a>
                      </div>
                    </div>
                    <div className="body-item">
                      <div className="item-title" style={{ paddingTop: 8 }}>
                        {React.language("Apps.need.update")}
                      </div>
                      <div className="item-cont">
                        <div className="cont-apps">
                          {res.appIds.map((res1) => {
                            const app = appsMap[res1];
                            return (
                              app && (
                                <div className="app-item" key={res1}>
                                  <div className="app-icon">
                                    <div
                                      className={`icon-backgroup color-cover-${app.style.color}`}
                                    >
                                      <div
                                        className={`imgbg-bsy-app imgbg-bsy-app-${app.style.icon}`}
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="app-name">{app.appname}</div>
                                </div>
                              )
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default UpdateStandardAppPane;
